// This file was automatically generated from appchart.confidentialCheckbox.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.confidentialCheckbox');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.confidentialCheckbox.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<label class="el8label el8CheckMarkSmall mr10"><input type="checkbox" name="confidential" /><span class="el8NormalText el8StandardFontSize">Keep this confidential (<a target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/confidential-items-in-your-patient-chart">What does this mean?</a>)</span></label>');
  if (!opt_sb) return output.toString();
};
